/* eslint-disable import/no-unresolved */
/* eslint-disable import/namespace */
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useSearchParams } from "react-router-dom";
import { loadRoles } from "../../slices/PermissionsSlice";
import Table from "../../components/admin/Table";
import defaultConfig from "../../config/Config";
import { useState, useMemo } from "react";

export function RolesList() {
  const [searchParams, setSearchParams] = useSearchParams()
  const [businessData, setBusinessData] = useState([]);
  const [columsData, setColumsData] = useState([]);
  const queryString = Object.fromEntries([...searchParams.entries()])
  const [defaultParams, setDefaultParams] = useState({
    pageLength:queryString.pageLength?queryString.pageLength:defaultConfig.defaultLimit,
    page:queryString.page?queryString.page:1,
  })
  const columns =  useMemo( ()=> [
    {
      name: "Role Name",
      selector: (row) => row.label,
      sortable: true,
      center: true,
    },
    {
      name: "Master Role",
      selector: (row) => row.isMaster,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
    },
    {
      name:"Created",
      selector: (row) => row.createdAt
    },
    {
      name: "Action",
      button: false,
      selector: "action",
      center: true,
      cell: (row) => (
        <React.Fragment>
          <Link to={`/edit-role/${row._id}`} className="sidebar-link" data-toggle="tab">
            {" "}
            <i className="fa fa-edit"></i>{" "}
          </Link>
        </React.Fragment>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
    },
  ],[]);
  const dispatch = useDispatch();
  const roleData = useSelector((state) => state.permissions) || []
  

  useEffect(()=>{
    if(Object.keys(queryString).length === 0){
      console.log("next")
      dispatch(loadRoles(defaultParams))
    }else{
      setDefaultParams({...defaultParams, ...queryString}) 
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[dispatch]);

  useEffect( () =>{
    setColumsData(columns)
  },[columns, defaultParams])

  const setPaginationData = (paginationData) =>{
    const params = {...defaultParams, page:paginationData.page, pageLength:paginationData.pageLength}
    setDefaultParams(params)
    setSearchParams(params)
  }

  return (
    <React.Fragment>
      <div className="revenue-wrapper">
        <div className="row">
          <div className="col-lg-12">
            <div className="card table-card">
              <div className="d-sm-flex justify-content-between align-items-center pl-4 pr-4">
                <h4 className="card-title mB25 mb-sm-0">Roles</h4>
                <div className="d-flex align-items-center">
                  <Link
                    to={"/add-roles"}
                    className="button blue-button mt-3"
                    data-toggle="tab"
                  >
                    Add Role
                  </Link>
                </div>
              </div>
              <Table 
                totalCount={roleData?.totalCount}
                data={roleData.userRoleData} 
                columns={columsData} 
                dataLoadFnc={loadRoles} 
                extraConfig = {defaultParams}  
                loading={businessData.loading}
                callBack={setPaginationData}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
